export default __webpack_public_path__ + "static/media/home-decor-img-13.28fd913f.jpg";